import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerSettingsTimeGroupInputsFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsTimeGroupInputsForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerSettingsTimeGroupInputsFormSchema,
  getDefaultCSSchedulerTimeGroupInputsValues,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import { omitKidneyOrganRules } from '@lp/features/Scheduler/utils';
import {
  useCSScheduleRegionsQuery,
  useCSSchedulePeriodTimeGroupInputsQuery,
  useCSSetSchedulePeriodTimeGroupInputsMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsTimeGroupInputsTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data: timeGroupInputs } = useCSSchedulePeriodTimeGroupInputsQuery();
  const { data: regionList } = useCSScheduleRegionsQuery();
  const { mutateAsync, isPending } = useCSSetSchedulePeriodTimeGroupInputsMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsInputsWrite);

  const handleSubmit = async (data: CSSchedulerSettingsTimeGroupInputsFormType) => {
    try {
      await mutateAsync({
        ...data,
        perRegions: omitKidneyOrganRules(data.perRegions),
        perHubs: omitKidneyOrganRules(data.perHubs),
      });

      toast.success(`Scheduler Time Group Inputs updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!regionList || !timeGroupInputs) {
    return <Spinner />;
  }

  return (
    <Form<CSSchedulerSettingsTimeGroupInputsFormType>
      defaultValues={getDefaultCSSchedulerTimeGroupInputsValues(regionList, timeGroupInputs)}
      // TMDXLP-14091
      // TODO: Remove after Kidney support
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      schema={csSchedulerSettingsTimeGroupInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <CSSchedulerSettingsTimeGroupInputsForm regions={regionList} isReadOnly={!hasWritePermissions} />
      <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
    </Form>
  );
};
